import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'

import { RepositoryModal, SubcontractorTrainingModule, SubcontractorTrainingQuestion } from '../../shared'
import { generateGuid } from '../../shared/shared-functions'

@Component({
    templateUrl: './training-module-modal.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class TrainingModuleModalComponent extends RepositoryModal<SubcontractorTrainingModule> {
    faPlus = faPlus
    faTrash = faTrash

    questionTypes = [
        { value: 'TrueFalse', label: 'True / False' },
        { value: 'MultipleChoice', label: 'Multiple Choice' },
    ]

    trueFalseAnswers = [
        { value: 'True', label: 'True' },
        { value: 'False', label: 'False' },
    ]

    addQuestion() {
        this.target.questions = this.target.questions ?? []
        this.target.questions.push({
            id: generateGuid(),
            moduleId: this.target.id,
            sortOrder: this.target.questions.length + 1,
            questionText: '',
            questionType: 'TrueFalse',
            optionsJson: '',
            correctAnswer: 'True',
            explanation: '',
        })
    }

    removeQuestion(index: number) {
        this.target.questions.splice(index, 1)
        this.target.questions.forEach((question, questionIndex) => (question.sortOrder = questionIndex + 1))
    }

    getOptions(question: SubcontractorTrainingQuestion): string[] {
        if (!question.optionsJson) return ['', '', '', '']
        try {
            const parsed = JSON.parse(question.optionsJson) as string[]
            return parsed.length ? parsed : ['', '', '', '']
        } catch {
            return ['', '', '', '']
        }
    }

    setOptions(question: SubcontractorTrainingQuestion, options: string[]) {
        question.optionsJson = JSON.stringify(options.filter(x => x.trim().length > 0))
    }

    updateOption(question: SubcontractorTrainingQuestion, index: number, value: string) {
        const options = this.getOptions(question)
        options[index] = value
        this.setOptions(question, options)
    }

    addOption(question: SubcontractorTrainingQuestion) {
        const options = this.getOptions(question)
        options.push('')
        this.setOptions(question, options)
    }

    removeOption(question: SubcontractorTrainingQuestion, index: number) {
        const options = this.getOptions(question)
        options.splice(index, 1)
        this.setOptions(question, options)
    }

    onBeforeSave() {
        this.target.questions = (this.target.questions ?? []).filter(x => x.questionText?.trim())
        this.target.questions.forEach((question, index) => {
            question.sortOrder = index + 1
            if (question.questionType === 'TrueFalse') {
                question.optionsJson = ''
            }
        })
        return true
    }
}
